import { Tabs } from 'antd';

import { Container } from 'components';

import { NewRetailerButton, RetailerGroupsTab, RetailersTab } from './components';

export const Retailers = () => (
  <Container>
    <Tabs
      // onChange={setActiveTab}
      // activeKey={activeTab}
      size='large'
      tabBarExtraContent={<NewRetailerButton />}
      items={[{
        key: '1',
        label: 'Retailers',
        children: <RetailersTab />,
      }, {
        key: '2',
        label: 'Retailer Groups',
        children: <RetailerGroupsTab />,
      }]}
    />
  </Container>
);
